<template>
  <i v-if="icon" :class="getIcon" />
</template>
<script lang="ts">
import { computed } from "vue";
import { Options } from "vue-class-component";
import BaseElement from "../BaseElement.vue";

@Options({})
export default class PIcon extends BaseElement {
  public getIcon = computed(() => `pi ${this.icon}`);
}
</script>
